<div class="row mb-1">
    <div class="col-md-10 col-12" *ngIf="!detailMode">
        <ng-content></ng-content>
    </div>
    <div class="col-md-2 col-12 text-right" *ngIf="!detailMode">
        <button class="btn btn-success mt-md-3" 
                [disabled]="!desativarBotao()"
                (click)="adicionarItem()">
            <i class="fa fa-plus mx-2"></i>
            Adicionar
        </button>
    </div>
</div>
<div class="row mb-1">
    <div class="col">
        <div *ngIf="!this.listaVazia() then mostraLista else mostraSemLista"></div>
        <ng-template #mostraLista>
            <div class="row mb-1 border-bottom">
                <div class="col-2">
                    <span *ngIf="!this.detailMode">REMOVER</span>
                </div>
                <div class="col" *ngFor="let col of this.obterCampos()">
                    {{col.toUpperCase()}}
                </div>
            </div>
            <div class="row mb-1 border-bottom" *ngFor="let item of this.obterLista(); let i = index">
                <div class="col-2">
                    <span *ngIf="!this.detailMode">
                        <i class="ft-trash-2 mx-2" title="Remover"
                            (click)="this.removerItem(i)"></i>
                    </span>
                </div> 
                <div *ngIf="listaCamposVazia() then mostraListaItens else mostraTabelaItens"></div>
                <ng-template #mostraTabelaItens>
                <div class="col" *ngFor="let nome of this.obterCampos()">
                    <span>{{item[nome]}}</span>
                </div>
                </ng-template>
                <ng-template #mostraListaItens>
                    <div class="col">
                        <span>{{item}}</span>
                    </div> 
                </ng-template>
            </div>
        </ng-template>
        <ng-template #mostraSemLista>
            <span class="bg-danger text-white px-2 py-1 rounded">Nenhum item vinculado.</span>
        </ng-template>
    </div>
</div>
